exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".caption_colored[data-v-0786def1] {\n  color: var(--caption-text-color);\n}\n", ""]);

